import axios from '../../../axios'

// 列表
export const list = (data) => {
  return axios({
    url: 'plan/weeklyPlan/list',
    method: 'post',
    data
  })
}
// 日历列表
export const calendarList = (data) => {
  return axios({
    url: 'plan/weeklyPlan/calendarList',
    method: 'post',
    data
  })
}
//拖拽保存
export const save = (data) => {
  return axios({
    url: 'plan/weeklyPlan/save',
    method: 'post',
    data
  })
}
//批量设置保存
export const saveWorkOrderSetting = (data) => {
  return axios({
    url: 'plan/weeklyPlan/saveWorkOrderSetting',
    method: 'post',
    data
  })
}
//编辑预选工单
export const editWorkOrder = (data) => {
  return axios({
    url: 'plan/weeklyPlan/editWorkOrder',
    method: 'post',
    data
  })
}
//提交预选工单编辑
export const submitEditWorkOrder = (data) => {
  return axios({
    url: 'plan/weeklyPlan/submitEditWorkOrder',
    method: 'post',
    data
  })
}

//新增预工单
export const submitWorkOrder = (data) => {
  return axios({
    url: 'plan/weeklyPlan/submitWorkOrder',
    method: 'post',
    data
  })
}

//删除预工单
export const deleteWorkOrder = (data) => {
  return axios({
    url: 'plan/weeklyPlan/deleteWorkOrder',
    method: 'post',
    data
  })
}







// WEBPACK FOOTER //
// ./src/http/moudules/biz/plan/weeklyPlan.js